import { c as _c } from "react/compiler-runtime";
import { groupBy } from "es-toolkit/array";
import { useExternalConnectors } from "../../../../../polychain/hooks";
import { CUSTOM_PRIVY_CONNECTORS } from "../../../../../polychain/hooks/useConnectors";
export const useConnectOptions = () => {
  const $ = _c(2);
  const externalConnectors = useExternalConnectors();
  let t0;
  if ($[0] !== externalConnectors) {
    const filteredConnectors = externalConnectors.filter(_temp);
    const groupedConnectors = groupBy(filteredConnectors, _temp2);
    t0 = Object.entries(groupedConnectors).map(_temp5);
    $[0] = externalConnectors;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(connector) {
  return !CUSTOM_PRIVY_CONNECTORS.has(connector.id);
}
function _temp2(c) {
  if (c.name.trim() === "Base Account") {
    return "Coinbase Wallet";
  }
  return c.name.trim();
}
function _temp3(connector_0) {
  return connector_0.isInstalled;
}
function _temp4(connector_1) {
  return connector_1.isConnected();
}
function _temp5(t0) {
  const [name, connectors] = t0;
  return {
    name,
    id: connectors[0].id,
    icon: connectors[0].icon,
    isInstalled: connectors.some(_temp3),
    isConnected: connectors.every(_temp4),
    connectors
  };
}